export function isBannerPreviewEnabled(
  cheatEnabled: boolean,
  storage: Storage | undefined = typeof localStorage !== "undefined" ? localStorage : undefined,
  search: string | undefined = typeof location !== "undefined" ? location.search : undefined,
): boolean {
  if (!cheatEnabled) return false;
  const query = search ? new URLSearchParams(search).get("bannerPreview") : null;
  if (query === "1" || query === "true") return true;
  if (query === "0" || query === "false") return false;
  return storage?.getItem("brick.bannerPreview") === "1";
}

export function toggleBannerPreview(
  cheatEnabled: boolean,
  storage: Storage | undefined = typeof localStorage !== "undefined" ? localStorage : undefined,
  reload: () => void = () => window.location.reload(),
): boolean {
  const next = !isBannerPreviewEnabled(cheatEnabled, storage);
  storage?.setItem("brick.bannerPreview", next ? "1" : "0");
  reload();
  return next;
}
